export const SCREEN_NAME = 'smart-rules';

export const SMART_RULES = 'smartRules';

export const STATUS_ACTIVE = 'Active';
export const STATUS_INACTIVE = 'Inactive';
export const STATUS_ERROR = 'Error';
export const STATUS_PENDING_FOR_START = 'PendingForStart';
export const STATUS_PENDING_FOR_APPROVAL = 'PendingForApproval';

export const STATUS_LABELS = {
  [STATUS_ACTIVE]: 'Active',
  [STATUS_INACTIVE]: 'Inactive',
  [STATUS_ERROR]: 'Error',
  [STATUS_PENDING_FOR_START]: 'Pending for start',
  [STATUS_PENDING_FOR_APPROVAL]: 'Pending for approval',
};

export const COLUMN_ID = 'id';
export const COLUMN_NAME = 'name';
export const COLUMN_STATUS = 'status';
export const COLUMN_AFFECTED_LEVEL = 'dimension';
export const COLUMN_LAST_RUN = 'lastRun';
export const COLUMN_LAST_RUN_RESULTS = 'lastRunResults';
export const COLUMN_NEXT_RUN = 'nextRun';
export const COLUMN_OWNER = 'owner';
export const COLUMN_UPDATED_DATE = 'dateUpdated';
export const COLUMN_CREATED_BY = 'createdBy';
export const COLUMN_CREATED_DATE = 'createdDate';
export const COLUMN_ACTIONS = 'actions';

export const FILTER_CREATED = 'created';
export const FILTER_STATUSES = 'statuses';
export const FILTER_SHOW = 'ruleShowMode';
export const FILTER_TYPE = 'ruleMode';
export const FILTER_AFFILIATES = 'affiliateIds';
export const FILTER_NETWORKS = 'networkIds';
export const FILTER_APPLICATIONS = 'applicationIds';
export const FILTER_PLATFORMS = 'platformIds';
export const FILTER_CREATED_BY = 'ruleCreatedByIds';
export const FILTER_CHANNELS = 'channelIds';

export const ACTION_START = 'START';
export const ACTION_STOP = 'STOP';
export const ACTION_EDIT = 'EDIT';
export const ACTION_COPY = 'COPY';
export const ACTION_APPROVE = 'APPROVE';
export const ACTION_REJECT = 'REJECT';
export const ACTION_REMOVE = 'REMOVE';

export const REORDER_COLUMNS = 'REORDER_COLUMNS';
export const COLLAPSE_COLUMNS = 'COLLAPSE_COLUMNS';

export const MY_RULES = 'My';
export const PERMISSION_ACTION_SMART_RULES_ADMIN = 10;
